import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';
import { Product } from 'src/app/models/core/product.model';
import { Share } from '@capacitor/share';

@Component({
  selector: 'app-share-code-modal',
  templateUrl: './share-code-modal.component.html',
  styleUrls: ['./share-code-modal.component.scss'],
  standalone: false
})
export class ShareCodeModalComponent implements OnInit {
  isNative = false;
  @Input() securityPhrase!: string;
  @Input() shareCode!: string;
  @Input() product!: Product;

  constructor(
    private modalCtrl: ModalController,
    private toast: CustomToastService,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.isNative = Capacitor.isNativePlatform();
  }

  get shareUrl(): string {
    return `${environment.ecommerceDomain}/event/${this.product.event.slug}?code=${this.shareCode}`;
  }

  get shareMessage(): string {
    return `${this.product.share_message}\nTu frase de seguridad es: ${this.securityPhrase}`;
  }

  get shareMessageToCopy(): string {
    return `${this.shareUrl}\n${this.shareMessage}`;
  }

  copyShareMessageToClipboard(
    successMsg = this.translate.instant('share-ticket-modal.copy-message-success'),
    errorMsg = this.translate.instant('share-ticket-modal.copy-message-error')
  ) {
    navigator.clipboard.writeText(this.shareMessageToCopy).then(() => {
      this.toast.show(successMsg, 3000, 'success');
    }).catch(() => {
      this.toast.show(errorMsg, 3000, 'error');
    });
  }

  shareWhatsApp() {
    const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(this.shareMessageToCopy)}`;
    window.open(url, '_blank');
  }

  shareInstagram() {
    const instaSuccess = this.translate.instant('share-microsite.instagram-copy-success');

    this.copyShareMessageToClipboard(instaSuccess);
    setTimeout(() => {
      window.open('https://www.instagram.com/accounts/login/?next=/', '_blank');
    }, 2100);
  }

  async shareMessageNative() {
    this.modalCtrl.dismiss();
    try {
      await Share.share({
        title: 'Compartir evento',
        text: this.shareMessageToCopy,
        dialogTitle: 'Compartir con...'
      });
    } catch (error) {
      console.error('Error al compartir:', error);
    }
  }

}
